import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { navLinks, contact } from '../mock';
import LionLogo from './LionLogo';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Top strip */}
      <div className="hidden md:block bg-[#2b1d0e] text-[#f7e6c2] text-sm">
        <div className="container-x flex justify-between items-center py-2">
          <span className="tracking-wide">Uttar Pradesh • India</span>
          <span>Open Tues – Sun</span>
        </div>
      </div>

      <header className={`nav-wrap ${scrolled ? 'shadow-sm' : ''}`}>
        <div className="container-x flex items-center justify-between h-[76px]">
          <Link to="/" className="flex items-center gap-3">
            <LionLogo size={46} variant="gold" />
            <div className="flex flex-col leading-tight">
              <span className="font-display text-lg text-[#2b1d0e] font-bold">Etawah Lion Safari</span>
              <span className="text-[11px] tracking-widest uppercase text-[#8b6520]">Uttar Pradesh · India</span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navLinks.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                className={({ isActive }) => `nav-link whitespace-nowrap text-sm ${isActive ? 'active' : ''}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <Link to="/tickets" className="hidden md:inline-flex btn-primary">
            Book Safari
          </Link>

          <button className="lg:hidden text-[#2b1d0e]" onClick={() => setOpen(!open)} aria-label="menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-[#e6d3b0] bg-[#fdfbf5]">
            <div className="container-x flex flex-col py-4 gap-2">
              {navLinks.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === '/'}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `py-2 px-2 rounded ${isActive ? 'text-[#b8791c] bg-[#f7e6c2]' : 'text-[#3d2a12]'}`}
                >
                  {n.label}
                </NavLink>
              ))}
              <Link to="/tickets" onClick={() => setOpen(false)} className="btn-primary justify-center mt-2">
                Book Safari
              </Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
